
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';
import { useSEO, getOrganizationSchema, getBreadcrumbSchema } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Isparta Hukuk Danışmanlık Yıldız & Başyiğit Hukuk',
    description: 'Isparta merkezinde hukuki danışmanlık hizmetleri sunan Yıldız & Başyiğit Hukuk Bürosu, ticaret hukuku, gayrimenkul hukuku, aile hukuku, ceza hukuku ve iş hukuku alanlarında uzman avukatlarla müvekkillerine profesyonel çözümler sunmaktadır. 4+ yıllık deneyimimizle hukuki sorunlarınıza güvenilir ve etkili çözümler üretiyoruz.',
    keywords: 'Isparta hukuk bürosu, hukuk danışmanlığı, avukat Isparta, ticaret hukuku, gayrimenkul hukuku, aile hukuku',
    ogImage: 'https://public.readdy.ai/ai/img_res/1ecfaa48f201cb4bf577a0544946af41.jpg',
    canonical: siteUrl,
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getBreadcrumbSchema([
          { name: 'Ana Sayfa', url: siteUrl }
        ]),
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'Yıldız & Başyiğit Hukuk ve Danışmanlık',
          description: 'Isparta merkezinde profesyonel hukuki danışmanlık hizmetleri',
          publisher: {
            '@id': `${siteUrl}/#organization`
          }
        },
        {
          '@type': 'LegalService',
          '@id': `${siteUrl}/#legalservice`,
          name: 'Yıldız & Başyiğit Hukuk ve Danışmanlık',
          description: 'Isparta merkezinde hukuki danışmanlık hizmetleri sunan Yıldız & Başyiğit Hukuk Bürosu',
          url: siteUrl,
          telephone: '+90 (246) 218 5000',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Çünür Mahallesi, 1916. Sokak No:8/A',
            addressLocality: 'Isparta',
            addressRegion: 'Isparta',
            postalCode: '32100',
            addressCountry: 'TR'
          },
          areaServed: {
            '@type': 'Place',
            name: 'Isparta'
          },
          serviceType: [
            'Ticaret Hukuku',
            'Gayrimenkul Hukuku', 
            'Aile Hukuku',
            'Ceza Hukuku',
            'İş Hukuku',
            'Tazminat Hukuku',
            'Miras Hukuku'
          ]
        }
      ]
    }
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
